import { useEffect } from "@wordpress/element";
import { MdOutlineTrendingDown, MdOutlineTrendingFlat, MdOutlineTrendingUp } from "react-icons/md";
import Typography from "../../../../componentsNew/Typography";

export default function IconStatus({ mudancaPorcentagem, valor, texto }) {
    return (
        <div className="flex">
            {mudancaPorcentagem != null &&
                mudancaPorcentagem < 0 ? <MdOutlineTrendingDown className="h-4 w-4 text-error-medium mr-2" /> :
                    mudancaPorcentagem > 0 ? <MdOutlineTrendingUp className="h-4 w-4 text-sucess-main mr-2" /> :
                        <MdOutlineTrendingFlat className="h-4 w-4 text-text-inactive mr-2" />
            }

            {valor != null && 
            <Typography component="tbody2-grafico-status" className={`${mudancaPorcentagem < 0 ? "text-error-medium" : mudancaPorcentagem > 0 ? "text-sucess-main" : "text-text-inactive"}`}>
                {texto} {valor} 
            </Typography>}
        </div>
    )
}